import React from 'react';
import { Route, Routes } from 'react-router-dom';
import UserManagementMain from '../Usermanagementmain/UserManagementMain'; // Import the new main component

function Usermanagement() {
   return (
      <Routes>
          <Route path="/" element={<UserManagementMain />} /> 
      </Routes>
    );
}

export default Usermanagement;